import React from "react";
import { Container } from "reactstrap";
import GlobalStateWrapper from "../../components/GlobalStateWrapper";

import {
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav
} from "@coreui/react";
import { URL } from "../../navigation/paths";
import routes from "../../navigation/routes";
import DefaultFooter from "./DefaultFooter";
import DefaultHeader from "./DefaultHeader";

const navigationStructure = {
  items: [
    {
      name: "Home",
      url: URL.homePage,
      icon: "fa fa-bars"
    },
    {
      name: "Novi putni račun",
      url: URL.createTravelExpense,
      icon: "fa fa-plus-square"
    },
    {
      name: "Putni računi",
      url: URL.getTravelExpense,
      icon: "fa fa-bars"
    },
    {
      name: "Korisnička prava",
      url: URL.userRole,
      icon: "fa fa-bars"
    },
    {
      name: "Izvještaji",
      url: URL.reports,
      icon: "fa fa-bars"
    }
  ]
};

const DefaultLayout = props => (
  <div className="app">
    <AppHeader fixed>
      <DefaultHeader />
    </AppHeader>
    <div className="app-body">
      <AppSidebar fixed display="lg">
        <AppSidebarHeader />
        <AppSidebarForm />
        <AppSidebarNav navConfig={navigationStructure} {...props} />
        <AppSidebarFooter />
        <AppSidebarMinimizer />
      </AppSidebar>
      <main className="main">
        <AppBreadcrumb appRoutes={routes} />
        <Container fluid>
          <GlobalStateWrapper />
        </Container>
      </main>
    </div>
    <AppFooter>
      <DefaultFooter />
    </AppFooter>
  </div>
);

export default DefaultLayout;
